// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let tooltip = TailwindVariants.tv({
  base: "group will-change-transform bg-black/75 text-white border-none rounded-md pl-2.5 pr-2.5 pt-1.5 pb-1.5 text-sm",
  variants: {
    isEntering: {
      true: "animate-in fade-in ease-out duration-200"
    },
    isExiting: {
      true: "animate-out fade-out ease-in duration-150"
    }
  }
});

let Styles = {
  tooltip: tooltip
};

function Tooltip(props) {
  return JsxRuntime.jsxs(ReactAriaComponents.TooltipTrigger, {
    children: [
      JsxRuntime.jsx(ReactAriaComponents.Pressable, {
        children: props.children
      }),
      JsxRuntime.jsx(ReactAriaComponents.Tooltip, {
        placement: "bottom left",
        children: JsxRuntime.jsx("div", {
          children: props.label
        }),
        ariaLabel: props.ariaLabel,
        className: renderProps => tooltip(renderProps),
        offset: 7.5
      })
    ],
    delay: 200
  });
}

let make = Tooltip;

exports.Styles = Styles;
exports.make = make;
/* tooltip Not a pure module */
